import React, { useEffect, useState } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Grid, Typography } from "@mui/material";
import Bottom from "../Bottom";
import Top from "../Top";
import HistoryLoadState from "../../components/HistoryLoadState";
import GaugeChart from "../../components/GaugeChart";
import ScatterChart from "../../components/ScatterChart";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Stack from '@mui/material/Stack';
import Avatar from '@mui/material/Avatar';
import Divider from '@mui/material/Divider';
import blood from "../../assets/icon/blood.gif";
import api from "../../utils/api";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import HistoryDrawerBloodInput from "../../components/HistoryDrawerBloodInput";
import { useNavigate } from "react-router-dom";
import { styled } from "@mui/material/styles";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import WbTwilightIcon from '@mui/icons-material/WbTwilight';
import LightModeIcon from '@mui/icons-material/LightMode';
import BedtimeIcon from '@mui/icons-material/Bedtime';
import FlareIcon from '@mui/icons-material/Flare';
import BedIcon from '@mui/icons-material/Bed';
import MuiInput from '@mui/material/Input';
import * as util from "../../utils/util";
import LineChart from "../../components/LineChart";
import { notifyApiError } from "../../utils/apiError";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const Input = styled(MuiInput)`
  width: 100px;
`;

const drawerBleeding = 56;

interface Props {
  window?: () => Window;
}

const params = {
  token: '',
  from: '',
  to: '',
  target: ''
}

const initTargetBlood = {
  bloodSugarMorning: 0,
  bloodSugarMorningAfter: 0,
  bloodSugarLunch: 0,
  bloodSugarLunchAfter: 0,
  bloodSugarDinner: 0,
  bloodSugarDinnerAfter: 0,
  bloodSugarSleep: 0
}

export default function HistoryBlood(props: Props) {
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  const { window } = props;
  const [open, setOpen] = React.useState(false);
  const toggleDrawer = (newOpen: boolean) => () => {
    setOpen(newOpen);
  };
  const container = window !== undefined ? () => window().document.body : undefined;

  const navigate = useNavigate();
  const [value, setValue] = React.useState(0);
  const [dayValue, setDayValue] = useState(0);
  /**
   * 화면 상단 날짜. 서버 응답이 아니라 dayValue 에서 바로 만든다.
   *
   * 예전에는 빈 문자열로 시작해 조회 성공(result_code === '0') 안에서만 채웠다.
   * 그래서 (1) 응답이 올 때까지 '..' 만 보였고 (2) 조회가 실패하면 영영 '..' 로 남았다.
   * 날짜는 클라이언트가 이미 아는 값이라 서버 응답에 묶어 둘 이유가 없다.
   */
  const targetDate = util.getDateByCustom('yyyyMMdd', dayValue);
  const [loading, setLoading] = React.useState(true);
  const [failed, setFailed] = React.useState(false);
  const [reloadNonce, setReloadNonce] = React.useState(0);
  const [targetBlood, setTargetBlood] = React.useState(initTargetBlood);
  /*
  const [series, setSeries] = React.useState([
    { label: '아침전', data: [{ x: 0, y: 0, id: '' }] }, { label: '아침후', data: [{ x: 0, y: 0, id: '' }] }, { label: '점심전', data: [{ x: 0, y: 0, id: '' }] }
    , { label: '점심후', data: [{ x: 0, y: 0, id: '' }] }, { label: '저녁전', data: [{ x: 0, y: 0, id: '' }] }, { label: '저녁후', data: [{ x: 0, y: 0, id: '' }] }
    , { label: '취침전', data: [{ x: 0, y: 0, id: '' }] }
  ]);
  */
  const [series, setSeries] = React.useState([{ curve: 'linear', data: [0], color: '' }]);
  const [xAxis, setXAxis] = React.useState([{ scaleType: 'point', data: [0] }]);

  useEffect(() => {
    setBloodData();
  }, [dayValue, reloadNonce]);

  function setBloodData() {
    setLoading(true);
    setFailed(false);
    // 혈압 정보 조회
    params.token = localStorage.getItem('token') || '';
    params.from = util.getDateByCustom('yyyyMMdd', dayValue - 7);
    params.to = util.getDateByCustom('yyyyMMdd', dayValue);
    params.target = util.getDateByCustom('yyyyMMdd', dayValue);

    api.get(`app/api/v1/AP_002_016?token=${params.token}&from=${params.from}&to=${params.to}&target=${params.target}`).then(res => {
      if (res.data.result_code === '0') {
        setTargetBlood(res.data.result_data.target);

        let tempArr = [];
        for (let item of res.data.result_data.data.blood_v2) {
          let obj = {
            bloodSugarMorning: 0, bloodSugarMorningAfter: 0, bloodSugarLunch: 0, bloodSugarLunchAfter: 0,
            bloodSugarDinner: 0, bloodSugarDinnerAfter: 0, bloodSugarSleep: 0, month: ''
          };
          obj.month = item.date;
          obj.bloodSugarMorning = item.bloodSugarMorning;
          obj.bloodSugarMorningAfter = item.bloodSugarMorningAfter;
          obj.bloodSugarLunch = item.bloodSugarLunch;
          obj.bloodSugarLunchAfter = item.bloodSugarLunchAfter;
          obj.bloodSugarDinner = item.bloodSugarDinner;
          obj.bloodSugarDinnerAfter = item.bloodSugarDinnerAfter;
          obj.bloodSugarSleep = item.bloodSugarSleep;
          tempArr.push(obj);
        }

        setSeries([
          { curve: 'linear', data: tempArr.map((v: any) => v.bloodSugarMorning), color: '#800d8d' },
          { curve: 'linear', data: tempArr.map((v: any) => v.bloodSugarMorningAfter), color: 'rgba(188,95,243,0.7)' },
          { curve: 'linear', data: tempArr.map((v: any) => v.bloodSugarLunch), color: '#2c6914' },
          { curve: 'linear', data: tempArr.map((v: any) => v.bloodSugarLunchAfter), color: '#77c059' },
          { curve: 'linear', data: tempArr.map((v: any) => v.bloodSugarDinner), color: '#d9448d' },
          { curve: 'linear', data: tempArr.map((v: any) => v.bloodSugarDinnerAfter), color: '#ec70ac' },
          { curve: 'linear', data: tempArr.map((v: any) => v.bloodSugarSleep), color: '#eac222' }
        ]);
        
        setXAxis([
          { scaleType: 'point', data: tempArr.map((v: any) => v.month) },
        ]);
        /*
        let tmpSeries = [
          { label: '아침전', data: tempArrReserver.map((v: any) => ({ x: Number(v.month), y: v.bloodSugarMorning, id: v.month })) },
          { label: '아침후', data: tempArrReserver.map((v: any) => ({ x: Number(v.month), y: v.bloodSugarMorningAfter, id: v.month })) },
          { label: '점심전', data: tempArrReserver.map((v: any) => ({ x: Number(v.month), y: v.bloodSugarLunch, id: v.month })) },
          { label: '점심후', data: tempArrReserver.map((v: any) => ({ x: Number(v.month), y: v.bloodSugarLunchAfter, id: v.month })) },
          { label: '저녁전', data: tempArrReserver.map((v: any) => ({ x: Number(v.month), y: v.bloodSugarDinner, id: v.month })) },
          { label: '저녁후', data: tempArrReserver.map((v: any) => ({ x: Number(v.month), y: v.bloodSugarDinnerAfter, id: v.month })) },
          { label: '취침전', data: tempArrReserver.map((v: any) => ({ x: Number(v.month), y: v.bloodSugarSleep, id: v.month })) }
        ]

        setSeries(tmpSeries);
        */
      } else {
        // result_code 가 '0' 이 아니면 조회 실패다. 예전에는 아무 처리도 없어서
        // 수치는 0 인 채로, 날짜는 '..' 로 굳고 사용자에게는 아무 안내도 없었다.
        console.warn('[기록] 조회 실패 result_code=', res.data.result_code, res.data.result_message);
        setFailed(true);
      }
    }).catch(function (error) {
      console.log(error);
      setFailed(true);
    }).finally(function () {
      setLoading(false);
    });
  }

  // 혈압 저장
  function saveBlood(data: { type: string, value: string }) {
    const saveParams = {
      date: '', bloodSugarMorning: 0, bloodSugarMorningAfter: 0, bloodSugarLunch: 0, bloodSugarLunchAfter: 0,
      bloodSugarDinner: 0, bloodSugarDinnerAfter: 0, bloodSugarSleep: 0
    };
    saveParams.date = targetDate.slice(0, 4) + '-' + targetDate.slice(4, 6) + '-' + targetDate.slice(6, 8);
    saveParams.bloodSugarMorning = targetBlood.bloodSugarMorning;
    saveParams.bloodSugarMorningAfter = targetBlood.bloodSugarMorningAfter;
    saveParams.bloodSugarLunch = targetBlood.bloodSugarLunch;
    saveParams.bloodSugarLunchAfter = targetBlood.bloodSugarLunchAfter;
    saveParams.bloodSugarDinner = targetBlood.bloodSugarDinner;
    saveParams.bloodSugarDinnerAfter = targetBlood.bloodSugarDinnerAfter;
    saveParams.bloodSugarSleep = targetBlood.bloodSugarSleep;
    // @ts-ignore
    saveParams[data.type] = data.value; // 입력한 혈당

    api.post(`app/api/v1/AP_002_017`, saveParams).then(res => {
      setBloodData();
    }).catch(function (error) {
      // 저장 실패를 알리지 않으면 사용자는 기록이 남은 줄 안다
      notifyApiError(error, '혈당 기록을 저장하지 못했습니다.');
    });
  }



  return (
    <Stack sx={{ width: '100%', minWidth: 320, background: '#F1F2F4', pb: 12, pl: 2, pr: 2, boxSizing: 'border-box' }} spacing={6}>
      <Top title="혈당 기록" />

      <Grid sx={{ bgcolor: '#F1F2F4', p: 0, width: '100%', minHeight: 500 }}>
        <Box>
          <Typography component="div" sx={{ fontSize: 20, color: '#555', m: 4, mb: 0, textAlign: 'center', fontWeight: 700 }}>
            <ArrowLeftIcon onClick={() => setDayValue((prev: any) => prev - 1)} sx={{ verticalAlign: 'text-bottom' }} />
            {targetDate.slice(0, 4) + '.' + targetDate.slice(4, 6) + '.' + targetDate.slice(6, 8)}
            <ArrowRightIcon onClick={() => setDayValue((prev: any) => prev + 1)} sx={{ 'display': dayValue < 0 ? 'inline-block' : 'none', verticalAlign: 'text-bottom' }} />
          </Typography>

          {/* 조회 중 / 실패 표시 — 날짜 바로 아래 한 줄 */}
          <HistoryLoadState loading={loading} failed={failed} onRetry={() => setReloadNonce((n) => n + 1)} />

          <Stack direction={'row'} justifyContent={'center'} sx={{ m: '20px 0', p: 1, bgcolor: '#fff', borderRadius: '15px', boxShadow: '0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)' }}>
            <Grid>
              <GaugeChart targetValue={util.getPressureStatusAndColor(util.getLatestValue(targetBlood).type, util.getLatestValue(targetBlood).bloodValue).gaugeValue} />
              <Typography component={'div'} sx={{ width: '100%', textAlign: 'center', color: util.getPressureStatusAndColor(util.getLatestValue(targetBlood).type, util.getLatestValue(targetBlood).bloodValue).color, fontSize: 16, fontWeight: 700, mb: 1 }}>
                {util.getPressureStatusAndColor(util.getLatestValue(targetBlood).type, util.getLatestValue(targetBlood).bloodValue).status}
              </Typography>
            </Grid>

            <Stack justifyContent={'center'} sx={{ m: 'auto', }}>
              <Avatar alt="" src={blood} sx={{ m: 'auto', width: '60px', height: '60px', borderRadius: 0 }} />
            </Stack>

            <Stack direction={'row'} alignItems={'center'} sx={{ ml: 'auto', mr: 2 }}>
              <Stack direction={'column'} sx={{ ml: 'auto' }}>
                <Typography component="div" sx={{ fontSize: 30, color: util.getPressureStatusAndColor(util.getLatestValue(targetBlood).type, util.getLatestValue(targetBlood).bloodValue).color, fontWeight: 700 }}>
                  {util.getLatestValue(targetBlood).bloodValue}
                </Typography>

                <Typography component="span" sx={{ fontSize: 18, color: '#777', mb: 0, textAlign: 'center' }}>
                  mg/dL
                </Typography>
              </Stack>
            </Stack>
          </Stack>

          <Accordion defaultExpanded sx={{ borderRadius: '15px', position: 'static', mb: 2 }}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              sx={{
                '&#panel1a-header': { minHeight: '55px', },
                '& .MuiAccordionSummary-content.Mui-expanded': { m: 0 }
              }}
            >
              <Typography sx={{ fontSize: 16, color: '#555', fontWeight: 700, }}>혈당 기록</Typography>
            </AccordionSummary>
            <Divider />

            <AccordionDetails>

              <Box className='bababab' sx={{ width: '100%', p: 0, '& div': { p: 0 } }}>
                {/* <Box >
                  <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" sx={CareButton}>
                    <Tab label="식전" {...a11yProps(0)} sx={CareButton} />
                    <Tab label="식후" {...a11yProps(1)} sx={CareButton} />
                  </Tabs>
                </Box> */}
                <CustomTabPanel value={value} index={0} >

                  <Stack direction={'row'} justifyContent={'space-evenly'} alignItems={'center'} sx={{ bgcolor: '#eee', borderRadius: 3 }}>
                    <Typography sx={{ p: 1, fontSize: 14, fontWeight: 700, color: '#555' }}>식전</Typography>
                    <Divider orientation="vertical" variant="middle" flexItem />
                    <Typography sx={{ p: 1, fontSize: 14, fontWeight: 700, color: '#555' }}>식후</Typography>
                  </Stack>

                  <Stack direction={'row'} alignItems={'center'} justifyContent={'space-around'} my={1.5} mt={2}>
                    <Stack justifyContent={'center'} alignItems={'center'} direction={'row'}>
                      <Typography component="div" sx={{ fontSize: 18, color: '#333', fontWeight: 700, textAlign: 'center', mr: 1 }}>{targetBlood.bloodSugarMorning}
                        <Typography component="div" sx={{ fontSize: 14, color: '#777', }}> mg/dL</Typography>
                      </Typography>
                      <HistoryDrawerBloodInput bloodType="bloodSugarMorning" bloodValue={targetBlood.bloodSugarMorning} saveBlood={saveBlood} />
                    </Stack>

                    <Stack justifyContent={'center'} alignItems={'center'} direction={'column'}>
                      <WbTwilightIcon sx={{ color: '#ef8322', mx: 1.5 }} />
                      <Typography component="div" sx={dailyTime}>아침</Typography>
                    </Stack>

                    <Stack justifyContent={'center'} alignItems={'center'} direction={'row'}>
                      <Typography component="div" sx={{ fontSize: 18, color: '#333', fontWeight: 700, textAlign: 'center', mr: 1 }}>{targetBlood.bloodSugarMorningAfter}
                        <Typography component="div" sx={{ fontSize: 14, color: '#777', }}> mg/dL</Typography>
                      </Typography>
                      <HistoryDrawerBloodInput bloodType="bloodSugarMorningAfter" bloodValue={targetBlood.bloodSugarMorningAfter} saveBlood={saveBlood} />
                    </Stack>
                  </Stack>
                  <Divider />

                  <Stack direction={'row'} alignItems={'center'} justifyContent={'space-around'} my={1.5}>
                    <Stack justifyContent={'center'} alignItems={'center'} direction={'row'}>
                      <Typography component="div" sx={{ fontSize: 18, color: '#333', fontWeight: 700, textAlign: 'center', mr: 1 }}>{targetBlood.bloodSugarLunch}
                        <Typography component="div" sx={{ fontSize: 14, color: '#777', }}> mg/dL</Typography>
                      </Typography>
                      <HistoryDrawerBloodInput bloodType="bloodSugarLunch" bloodValue={targetBlood.bloodSugarLunch} saveBlood={saveBlood} />
                    </Stack>

                    <Stack justifyContent={'center'} alignItems={'center'} direction={'column'}>
                      <LightModeIcon sx={{ color: '#fd5c5c', mx: 1.5 }} />
                      <Typography component="div" sx={dailyTime}>점심</Typography>
                    </Stack>

                    <Stack justifyContent={'center'} alignItems={'center'} direction={'row'}>
                      <Typography component="div" sx={{ fontSize: 18, color: '#333', fontWeight: 700, textAlign: 'center', mr: 1 }}>{targetBlood.bloodSugarLunchAfter}
                        <Typography component="div" sx={{ fontSize: 14, color: '#777', }}> mg/dL</Typography>
                      </Typography>
                      <HistoryDrawerBloodInput bloodType="bloodSugarLunchAfter" bloodValue={targetBlood.bloodSugarLunchAfter} saveBlood={saveBlood} />
                    </Stack>
                  </Stack>

                  <Divider />

                  <Stack direction={'row'} alignItems={'center'} justifyContent={'space-around'} my={1.5}>
                    <Stack justifyContent={'center'} alignItems={'center'} direction={'row'}>
                      <Typography component="div" sx={{ fontSize: 18, color: '#333', fontWeight: 700, textAlign: 'center', mr: 1 }}>{targetBlood.bloodSugarDinner}
                        <Typography component="div" sx={{ fontSize: 14, color: '#999', }}> mg/dL</Typography>
                      </Typography>
                      <HistoryDrawerBloodInput bloodType="bloodSugarDinner" bloodValue={targetBlood.bloodSugarDinner} saveBlood={saveBlood} />
                    </Stack>

                    <Stack justifyContent={'center'} alignItems={'center'} direction={'column'}>
                      <BedtimeIcon sx={{ color: '#ffb70d', mx: 1.5 }} />
                      <Typography component="div" sx={dailyTime}>저녁</Typography>
                    </Stack>

                    <Stack justifyContent={'center'} alignItems={'center'} direction={'row'}>
                      <Typography component="div" sx={{ fontSize: 18, color: '#333', fontWeight: 700, textAlign: 'center', mr: 1 }}>{targetBlood.bloodSugarDinnerAfter}
                        <Typography component="div" sx={{ fontSize: 14, color: '#999', }}> mg/dL</Typography>
                      </Typography>
                      <HistoryDrawerBloodInput bloodType="bloodSugarDinnerAfter" bloodValue={targetBlood.bloodSugarDinnerAfter} saveBlood={saveBlood} />
                    </Stack>
                  </Stack>
                </CustomTabPanel>

                {/* <CustomTabPanel value={value} index={1}>
                  <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'} my={1.5} mt={2}>
                    <Stack justifyContent={'center'} alignItems={'center'} direction={'row'}>
                      <WbTwilightIcon sx={{ color: '#ef8322', mx: 1.5 }} />
                      <Typography component="div" sx={dailyTime}>아침</Typography>
                    </Stack>

                    <Stack justifyContent={'center'} alignItems={'center'} direction={'row'}>
                      <Typography component="div" sx={{ fontSize: 18, color: '#333', fontWeight: 700, textAlign: 'right', mr: 1 }}>{targetBlood.bloodSugarMorningAfter}
                        <Typography component="span" sx={{ fontSize: 14, color: '#999', }}> mg/dL</Typography>
                      </Typography>
                      <HistoryDrawerBloodInput bloodType="bloodSugarMorningAfter" bloodValue={targetBlood.bloodSugarMorningAfter} saveBlood={saveBlood} />
                    </Stack>
                  </Stack>
                  <Divider />

                  <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'} my={1.5}>
                    <Stack justifyContent={'center'} alignItems={'center'} direction={'row'}>
                      <LightModeIcon sx={{ color: '#fd5c5c', mx: 1.5 }} />
                      <Typography component="div" sx={dailyTime}>점심</Typography>
                    </Stack>

                    <Stack justifyContent={'center'} alignItems={'center'} direction={'row'}>
                      <Typography component="div" sx={{ fontSize: 18, color: '#333', fontWeight: 700, textAlign: 'right', mr: 1 }}>{targetBlood.bloodSugarLunchAfter}
                        <Typography component="span" sx={{ fontSize: 14, color: '#999', }}> mg/dL</Typography>
                      </Typography>
                      <HistoryDrawerBloodInput bloodType="bloodSugarLunchAfter" bloodValue={targetBlood.bloodSugarLunchAfter} saveBlood={saveBlood} />
                    </Stack>
                  </Stack>
                  <Divider />

                  <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'} my={1.5}>
                    <Stack justifyContent={'center'} alignItems={'center'} direction={'row'}>
                      <BedtimeIcon sx={{ color: '#ffb70d', mx: 1.5 }} />
                      <Typography component="div" sx={dailyTime}>저녁</Typography>
                    </Stack>

                    <Stack justifyContent={'center'} alignItems={'center'} direction={'row'}>
                      <Typography component="div" sx={{ fontSize: 18, color: '#333', fontWeight: 700, textAlign: 'right', mr: 1 }}>{targetBlood.bloodSugarDinnerAfter}
                        <Typography component="span" sx={{ fontSize: 14, color: '#999', }}> mg/dL</Typography>
                      </Typography>
                      <HistoryDrawerBloodInput bloodType="bloodSugarDinnerAfter" bloodValue={targetBlood.bloodSugarDinnerAfter} saveBlood={saveBlood} />
                    </Stack>
                  </Stack>
                  <Divider />
                </CustomTabPanel> */}

                <Stack direction={'row'} justifyContent={'space-evenly'} alignItems={'center'} mt={2} sx={{ bgcolor: '#eee', borderRadius: 3 }}>
                  <Typography sx={{ p: 1, fontSize: 14, fontWeight: 700, color: '#555' }}>취침 전</Typography>
                </Stack>

                <Stack direction={'row'} alignItems={'center'} justifyContent={'space-evenly'} my={1.5}>
                  <Stack justifyContent={'center'} alignItems={'center'} direction={'row'}>
                    <BedIcon sx={{ color: '#aa1eff', mr:1 }} />
                    <Typography component="div" sx={dailyTime}>취침 전</Typography>
                  </Stack>

                  <Stack justifyContent={'center'} alignItems={'center'} direction={'row'}>
                    <Typography component="div" sx={{ fontSize: 18, color: '#333', fontWeight: 700, textAlign: 'right', mr: 1 }}>{targetBlood.bloodSugarSleep}
                      <Typography component="span" sx={{ fontSize: 14, color: '#999', }}> mg/dL</Typography>
                    </Typography>
                    <HistoryDrawerBloodInput bloodType="bloodSugarSleep" bloodValue={targetBlood.bloodSugarSleep} saveBlood={saveBlood} />
                  </Stack>
                </Stack>

              </Box>

            </AccordionDetails>
          </Accordion>



          <Box sx={{ bgcolor: '#fff', p: '0 10px 10px 10px', borderRadius: '15px', boxShadow: '0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)' }}>
            <Stack direction={'row'} justifyContent={'center'} alignItems={'center'} sx={{ p: 1 }}>
              <Stack >
                <Typography component="div" sx={{ fontSize: 14, color: '#555', }}>최근 7일</Typography>
              </Stack>
              <Stack sx={{ ml: 'auto', zIndex: 2 }} >
                <Button sx={{ fontSize: 12, color: '#555', }} endIcon={<ArrowRightIcon />}
                  onClick={() => { navigate('../history/BloodMonthHistory', { state: { type: 'blood' } }) }}>
                  월간현황
                </Button>
              </Stack>
            </Stack>
            <Divider />

            <Box sx={{ mt: -3.5, mb: 1 }}>
              <Box sx={{
                '& .MuiLineElement-root': {strokeWidth:0},
                '& .MuiMarkElement-series-auto-generated-id-0': {strokeWidth:0, fill:'#800d8d'},
                '& .MuiMarkElement-series-auto-generated-id-1': {strokeWidth:0, fill:'#bc5ff3b3'},
                '& .MuiMarkElement-series-auto-generated-id-2': {strokeWidth:0, fill:'#2c6914'},
                '& .MuiMarkElement-series-auto-generated-id-3': {strokeWidth:0, fill:'#77c059'},
                '& .MuiMarkElement-series-auto-generated-id-4': {strokeWidth:0, fill:'#d9448d'},
                '& .MuiMarkElement-series-auto-generated-id-5': {strokeWidth:0, fill:'#ec70ac'},
                '& .MuiMarkElement-series-auto-generated-id-6': {strokeWidth:0, fill:'#eac222'},


                }}>
                <LineChart series={series} xAxis={xAxis} isReferenceLine={false} />
              </Box>
              {/*<ScatterChart series={series} colors={['#800d8d', 'rgba(188,95,243,0.7)', '#2c6914', '#77c059', '#d9448d', '#ec70ac', '#eac222']} />*/}
              <Stack direction={'row'} justifyContent={'center'} alignItems={'center'} mt={'-10px'} mb={.5}>
                <Stack direction={'row'} justifyContent={'center'} alignItems={'center'} mr={1}>
                  <Box sx={{ width: 10, height: 10, bgcolor: '#800d8d', mr: .5, borderRadius: 3 }}></Box>
                  <Typography sx={{ fontSize: 12, color: '#777' }}>아침 식전</Typography>
                </Stack>
                <Stack direction={'row'} justifyContent={'center'} alignItems={'center'} mr={1} >
                  <Box sx={{ width: 10, height: 10, bgcolor: 'rgba(188,95,243,0.7)', mr: .5, borderRadius: 3 }}></Box>
                  <Typography sx={{ fontSize: 12, color: '#777' }}>아침 식후</Typography>
                </Stack>
                <Stack direction={'row'} justifyContent={'center'} alignItems={'center'} mr={1} >
                  <Box sx={{ width: 10, height: 10, bgcolor: '#2c6914', mr: .5, borderRadius: 3 }}></Box>
                  <Typography sx={{ fontSize: 12, color: '#777' }}>점심 식전</Typography>
                </Stack>
                <Stack direction={'row'} justifyContent={'center'} alignItems={'center'} mr={1} >
                  <Box sx={{ width: 10, height: 10, bgcolor: '#77c059', mr: .5, borderRadius: 3 }}></Box>
                  <Typography sx={{ fontSize: 12, color: '#777' }}>점심 식후</Typography>
                </Stack>
              </Stack>
              <Stack direction={'row'} justifyContent={'center'} alignItems={'center'}>
                <Stack direction={'row'} justifyContent={'center'} alignItems={'center'} mr={1} >
                  <Box sx={{ width: 10, height: 10, bgcolor: '#d9448d', mr: .5, borderRadius: 3 }}></Box>
                  <Typography sx={{ fontSize: 12, color: '#777' }}>저녁 식전</Typography>
                </Stack>
                <Stack direction={'row'} justifyContent={'center'} alignItems={'center'} mr={1} >
                  <Box sx={{ width: 10, height: 10, bgcolor: '#ec70ac', mr: .5, borderRadius: 3 }}></Box>
                  <Typography sx={{ fontSize: 12, color: '#777' }}>저녁 식후</Typography>
                </Stack>
                <Stack direction={'row'} justifyContent={'center'} alignItems={'center'} >
                  <Box sx={{ width: 10, height: 10, bgcolor: '#eac222', mr: .5, borderRadius: 3 }}></Box>
                  <Typography sx={{ fontSize: 12, color: '#777' }}>취침 전</Typography>
                </Stack>
              </Stack>
            </Box>
          </Box>
          <Box sx={{ p: 2 }}>
            <Typography sx={{ fontSize: 12, color: '#777', fontWeight: 700 }}>혈당정상범위</Typography>
            <Typography sx={{ fontSize: 12, color: '#888', }}>- 식전 70~100mg/dL - 식후(2시간) 90~140mg/dL</Typography>
            <Typography sx={{ fontSize: 12, color: '#888', }}>- 취침전 100~150mg/dL</Typography>
          </Box>
        </Box>
      </Grid>

      <Bottom />
    </Stack>
  );
}

const dailyTime = {
  width: 45, textAlign: 'center', fontSize: 14, color: '#777', fontWeight: 700
}

const CareButton = {
  boxShadow: 'none',
  textTransform: 'none',
  fontSize: 16,
  fontWeight: 500,
  padding: '6px 30px',
  lineHeight: 1.5,
  backgroundColor: '#FFB068',
  borderRadius: '20px',
  flex: 1,
  color: '#fff',
  minHeight: 'auto',

  '&.Mui-selected': {
    backgroundColor: '#EF8322',
    boxShadow: 'none',
    color: '#fff',
    fontWeight: 700,
  },
  '& .MuiTabs-indicator': {
    display: 'none'
  },
}